import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    loading: true,
    cachePolicies: [],
    cachePolicy: {},
    cachePolicyPagination: {},
    fetchingPolicies: false,
    addingPolicy: false,
    removingPolicy: false,
    updatingPolicy: false,
    gettingPolicy: false,
  },
  mutations: {
    // API
    SET_CACHEPOLICIES(state, data) {
      state.cachePolicies = data.result
      state.cachePolicyPagination = data.resultInfo
    },
    GET_CACHEPOLICY(state, data) {
      state.cachePolicy = data
    },
    SET_FETCHING_CACHEPOLIES(state, value) {
      state.fetchingPolicies = value
    },
    SET_ADDING_CACHEPOLICY(state, value) {
      state.addingPolicy = value
    },
    SET_REMOVING_CACHEPOLICY(state, value) {
      state.removingPolicy = value
    },
    REMOVE_CACHEPOLICY(state, id) {
      state.cachePolicies = state.cachePolicies.filter(u => u.id !== id)
    },
    SET_GETTING_CACHEPOLICY(state, value) {
      state.gettingPolicy = value
    },
    SET_UPDATING_CACHEPOLICY(state, value) {
      state.updatingPolicy = value
    },
  },
  actions: {
    fetchCachePolicies({ commit }, payload) {
      const query = `?pageIndex=${payload.pageIndex}&pageSize=${payload.pageSize}`
      commit('SET_FETCHING_CACHEPOLIES', true)
      return new Promise((resolve, reject) => {
        api('cdn').get(`/projects/${projectId()}/cachepolicies${query}`)
          .then(response => {
            commit('SET_CACHEPOLICIES', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_CACHEPOLIES', false) })
      })
    },

    addCachePolicy({ commit }, query) {
      commit('SET_ADDING_CACHEPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').post(`/projects/${projectId()}/cachepolicies`, query)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_CACHEPOLICY', false) })
      })
    },

    updateCachePolicy({ commit }, query) {
      commit('SET_UPDATING_CACHEPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').put(`/projects/${projectId()}/cachepolicies/${query.id}`, query)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_CACHEPOLICY', false) })
      })
    },

    removeCachePolicy({ commit }, id) {
      commit('SET_REMOVING_CACHEPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').delete(`/projects/${projectId()}/cachepolicies/${id}`)
          .then(response => {
            commit('REMOVE_CACHEPOLICY', id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_CACHEPOLICY', false) })
      })
    },
    getCachePolicy({ commit }, id) {
      commit('SET_GETTING_CACHEPOLICY', true)
      return new Promise((resolve, reject) => {
        api('cdn').get(`/projects/${projectId()}/cachepolicies/${id}`)
          .then(response => {
            commit('GET_CACHEPOLICY', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_GETTING_CACHEPOLICY', false) })
      })
    },
  },
}
